import { createFileRoute } from "@tanstack/react-router";
import { routeOptions } from "@/pages/pricing";
import { enRouteOptions } from "@/lib/route-i18n";

export const Route = createFileRoute("/en/pricing")(
  enRouteOptions(routeOptions, {
    svPath: "/pricing",
    title: 'Pricing – Swedish Alcohol Licence Test Practice',
    description: 'Prepare for the Swedish alcohol serving licence test: 10 days SEK 199, 30 days SEK 349 or 90 days SEK 599 incl. VAT. One-off payment, no subscription.',
    ogImage: "https://alkoholprovet.se/og/default.jpg",
    noindex: false,
  }),
);
